import { useParams } from "react-router-dom";
import { useGetByPlanting } from "../../api/scouting";
import { MetaDataCard } from "../../components/shared/MetaDataCard";
import { InfoCard } from "../../components/cards/info-card";

const PlantingDetail = () => {
  const { id } = useParams();
  const plantingId = id ? Number(id) : undefined;
  const { data: planting } = useGetByPlanting(plantingId as number);

  const plantingDetail = planting?.data?.data;

  const statData = [
    {
      title: "Date",
      value: plantingDetail?.date,
    },
    {
      title: "Planting Density",
      value: plantingDetail?.plantingDensity,
    },
    {
      title: "Emergence Rate (%)",
      value: plantingDetail?.emergencyRate,
    },

    {
      title: "Initial Health Observations",
      value: plantingDetail?.initialHealthObservations,
    },
    {
      title: "Preparation Rating (%)",
      value: plantingDetail?.preparationRating,
    },
  ];

  const seedingData = [
    {
      title: "Seeding Type",
      value: plantingDetail?.details?.seedlingsInformation?.seedlingType,
    },
    {
      title: "Variety",
      value: plantingDetail?.details?.seedlingsInformation?.variety,
    },
  ];

  const fertilizerData = [
    {
      title: "Fertilizer Type",
      value: plantingDetail?.details?.fertilizerApplication?.fertilizerType,
    },
    {
      title: "Application Method",
      value: plantingDetail?.details?.fertilizerApplication?.applicationMethod,
    },
    {
      title: "Quantity",
      value: plantingDetail?.details?.fertilizerApplication?.quantity,
    },
  ];

  return (
    <div className="min-h-screen bg-white py-8 mt-6">
      {/* Main Content */}
      <div className="p-6 space-y-8">
        {/* Field Assessment Section */}
        <section className="p-6 rounded-2xl border border-[#EBEBEB] gap-[10px]">
          <h2 className="text-base font-semibold text-gray-800 mb-4 pb-2">
            Field Assessment
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            {statData.map((stat, index) => (
              <InfoCard
                title={stat.title}
                value={stat.value as any}
                key={index}
              />
            ))}
          </div>
        </section>

        {/* Recommendations Section */}
        <section className="p-6 rounded-2xl border border-[#EBEBEB] gap-[10px]">
          <div className="text-sm ">
            <p className="text-[#000000]/50">Recommendations</p>
            <p className="text-[#000000]">{plantingDetail?.recommendations}</p>
          </div>
        </section>

        {/* Seedling Information & Fertilizer Section */}
        <section className="flex gap-2 w-full">
          {/* Seedling Information */}
          <section className="p-6 rounded-2xl border border-[#EBEBEB] w-[40%]">
            <h2 className="text-base font-semibold text-gray-800 mb-4  pb-2">
              Seedling Information
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {seedingData.map((stat, index) => (
                <InfoCard
                  title={stat.title}
                  value={stat.value as any}
                  key={index}
                />
              ))}
            </div>
          </section>

          {/* Fertilizer Section */}
          <section className="p-6 rounded-2xl border border-[#EBEBEB] w-[60%]">
            <div className="flex items-center mb-4">
              <h2 className="text-base font-semibold text-gray-800">
                Fertilizer
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {fertilizerData.map((stat, index) => (
                <InfoCard
                  title={stat.title}
                  value={stat.value as any}
                  key={index}
                />
              ))}
            </div>
          </section>
        </section>

        {/* Metadata Section */}
        <MetaDataCard
          metadata={plantingDetail}
          title="Metadata"
          cardBackgroundColor="white"
        />
      </div>
    </div>
  );
};

export default PlantingDetail;
